import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { getOverallDisbursement } from '../../../redux/actions/adminReport'
import OverallDisbursementReportWidget from '../../../widgets/adminReport/overallDisbursementReportWidgets/OverallDisbursementReportWidget'

export default function ProjectInfoAccordingReviewCycle(props) {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getOverallDisbursement()
      console.log('res ', _schema)
      setSchema(_schema)
      // setSchema(mockSchema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    // console.log('load AllProjectSummaryReport')
    handleGetSchema()
  }, [])

  if (error) {
    return (
      <SidebarProposal isReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }
  return (
    <SidebarProposal isReport>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />

      <OverallDisbursementReportWidget schema={schema.form.searchObject} />
    </SidebarProposal>
  )
}

// const mockSchema = {
//   header: 'รายงาน',
//   subHeader: 'ภาพรวมการเบิกจ่าย และเงินเหลือคืนของเงินอุดหนุนโครงการ',
//   form: {
//     searchObject: {
//       header: 'ค้นหาข้อมูล',
//       reportName: 'ภาพรวมการเบิกจ่าย และเงินเหลือคืนของเงินอุดหนุนโครงการ',
//       buttonText: {
//         disabled: true,
//         downloadButtonName: 'ดาวน์โหลด',
//         previewButtonName: 'ตัวอย่างก่อนพิมพ์',
//         cancelButtonName: 'ยกเลิก',
//         searchButtonName: null,
//       },
//       budgetYearStartOption: {
//         name: 'budgetYearStart',
//         label: 'ปีงบประมาณเริ่มต้น : ',
//         value: null,
//         disabled: true,
//         options: [
//           {
//             label: '2564',
//             value: 2564,
//           },
//           {
//             label: '2565',
//             value: 2565,
//           },
//           {
//             label: '2566',
//             value: 2566,
//           },
//           {
//             label: '2567',
//             value: 2567,
//           },
//         ],
//       },
//       budgetYearEndOption: {
//         name: 'budgetYearEnd',
//         label: 'ปีงบประมาณสิ้นสุด : ',
//         value: null,
//         disabled: true,
//         options: [
//           {
//             label: '2564',
//             value: 2564,
//           },
//           {
//             label: '2565',
//             value: 2565,
//           },
//           {
//             label: '2566',
//             value: 2566,
//           },
//           {
//             label: '2567',
//             value: 2567,
//           },
//         ],
//       },
//       projectCode: {
//         name: 'projectCode',
//         label: 'รหัสโครงการ : ',
//         value: null,
//         disabled: false,
//       },
//       projectDepartment: {
//         name: 'projectDepartment',
//         label: 'สำนัก : ',
//         value: null,
//         disabled: true,
//         options: [
//           {
//             label: 'ฝ่ายอำนวยการ',
//             value: 0,
//           },
//           {
//             label: 'สำนัก 1',
//             value: 1,
//           },
//           {
//             label: 'สำนัก 2',
//             value: 2,
//           },
//           {
//             label: 'สำนัก 3',
//             value: 3,
//           },
//           {
//             label: 'สำนัก 4',
//             value: 4,
//           },
//           {
//             label: 'สำนัก 5',
//             value: 5,
//           },
//           {
//             label: 'สำนัก 6',
//             value: 6,
//           },
//           {
//             label: 'สำนัก 7',
//             value: 7,
//           },
//           {
//             label: 'สนย.',
//             value: 8,
//           },
//           {
//             label: 'สภส.',
//             value: 9,
//           },
//           {
//             label: 'ศรร.',
//             value: 10,
//           },
//           {
//             label: 'ฝ่ายบริหารบุคคล',
//             value: 11,
//           },
//           {
//             label: 'ฝ่ายเทคโนโลยีฯ',
//             value: 12,
//           },
//           {
//             label: 'ฝ่ายสื่อสารองค์กร',
//             value: 13,
//           },
//           {
//             label: 'ฝ่ายบัญชีฯ',
//             value: 14,
//           },
//           {
//             label: 'สำนัก 8',
//             value: 15,
//           },
//           {
//             label: 'สำนัก 9',
//             value: 16,
//           },
//           {
//             label: 'ฝ่ายตรวจสอบภายใน',
//             value: 17,
//           },
//           {
//             label: 'กลุ่มงานวิชาการฯ',
//             value: 18,
//           },
//           {
//             label: 'สำนักสื่อสารการตลาดเพื่อสังคม',
//             value: 19,
//           },
//           {
//             label: 'สำนักวิชาการและนวัตกรรม',
//             value: 20,
//           },
//           {
//             label: 'ฝ่ายติดตามประเมินผล',
//             value: 21,
//           },
//           {
//             label: 'ศูนย์สัญญา',
//             value: 22,
//           },
//           {
//             label: 'สำนัก 10',
//             value: 23,
//           },
//           {
//             label: 'สสค.',
//             value: 24,
//           },
//           {
//             label: 'สำนัก 11',
//             value: 25,
//           },
//           {
//             label: 'ThaiHealth Academy',
//             value: 26,
//           },
//           {
//             label: 'SOOK Enterprise',
//             value: 27,
//           },
//           {
//             label: 'สำนักผู้จัดการ',
//             value: 90,
//           },
//         ],
//       },
//       projectStatusOption: {
//         name: 'projectStatusOption',
//         label: 'สถานะโครงการ : ',
//         value: null,
//         disabled: false,
//         options: [
//           {
//             label: 'ร่างข้อเสนอ',
//             value: 1,
//           },
//           {
//             label: 'ยื่นข้อเสนอโครงการ',
//             value: 2,
//           },
//           {
//             label: 'คัดกรอง',
//             value: 3,
//           },
//           {
//             label: 'กลั่นกรอง',
//             value: 4,
//           },
//           {
//             label: 'อนุมัติ',
//             value: 5,
//           },
//           {
//             label: 'ดำเนินการ',
//             value: 6,
//           },
//           {
//             label: 'รอยกเลิกโครงการ',
//             value: 7,
//           },
//           {
//             label: 'สละสิทธิ์โครงการ',
//             value: 8,
//           },
//           {
//             label: 'ปิดโครงการ',
//             value: 9,
//           },
//           {
//             label: 'ยุติโครงการ',
//             value: 10,
//           },
//           {
//             label: 'ทำสัญญา',
//             value: 11,
//           },
//           {
//             label: 'ระงับโครงการ',
//             value: 12,
//           },
//           {
//             label: 'ยกเลิกโครงการ/ยุติโครงการ',
//             value: 55,
//           },
//           {
//             label: 'ยกเลิกโครงการ',
//             value: 70,
//           },
//           {
//             label: 'ไม่เข้าข่าย (สสส.)',
//             value: 77,
//           },
//           {
//             label: 'ไม่สนับสนุน',
//             value: 88,
//           },
//           {
//             label: 'ไม่ใช้',
//             value: 99,
//           },
//         ],
//       },
//       projectStartDate: {
//         name: 'projectStartDate',
//         label: 'วันที่เริ่มต้นโครงการ : ',
//         value: null,
//         disabled: true,
//       },
//       projectEndDate: {
//         name: 'projectEndDate',
//         label: 'วันที่สิ้นสุดโครงการ : ',
//         value: null,
//         disabled: true,
//       },
//     },
//   },
// }
